
function CTA(){

    document.querySelectorAll('.cta-button span').forEach(function (elem) {
        var splitText = new SplitText(elem, {
            type: "chars, words, lines",
            wordsClass: "split-words",
            charsClass: "split-chars"
        });

        splitText.chars.forEach(function (char, index){
            char.style.transitionDelay = 0.05 + index / 50 + 's';
        });
    });

}